/**
 * check if a value is encrypted
 * @poram value {STRING}
 * @returns {Boolean} 
 */
export const isEncryptedValue = (value) => {
  // Check if value is a string and starts with $2$ and ends with $3$
  return (
    typeof value === 'string' &&
    value.startsWith('$2$') &&
    value.endsWith('$3$')
  );
};
